import { HTTPError } from '../typings';
import hasAccessToken from './has-access-token';
import getAuthHeaders from './get-auth-headers';
/**
 * useFetch hook returns a function that will make syf API calls. It will include required headers including authorization token and session id taken from sessionStorage.
 * @param config An MFE config object that includes apigee host names to use and an error callback in case of HTTP responses other than 200
 * @returns A function that wraps fetch. This wrapper function automatically adds required headers to syf API calls, it also parses the response.
 */
const fetchConfig = (config) => {
    async function fetchWrapper(url, init) {
        const fullUrl = new URL(url, config.hosts.apigee);
        const { headers = {}, ...rest } = init;
        let contentType = 'application/json';
        if (!init.method || init.method?.toUpperCase() === 'GET') {
            contentType = '';
        }
        const defaultHeader = {
            mode: 'cors',
            headers: {
                'Content-Type': contentType,
                Accept: 'application/json'
            },
            ...rest
        };
        const authenticatedHeader = {
            ...defaultHeader,
            headers: {
                ...defaultHeader.headers,
                ...headers,
                ...getAuthHeaders()
            }
        };
        const fetchOptions = !hasAccessToken() ? defaultHeader : authenticatedHeader;
        const response = await fetch(fullUrl.toString(), fetchOptions);
        const status = response?.status;
        if (!response.ok) {
            const err = new HTTPError(response);
            config.apiErrorCallback(err);
        }
        if (response.status === 204) {
            return null;
        }
        try {
            const text = await response.text();
            const parsedText = JSON.parse(text);
            if (status >= 400) {
                return { ...parsedText, statusCode: status };
            }
            return parsedText;
        }
        catch (_e) {
            throw new HTTPError(response);
        }
    }
    return fetchWrapper;
};
export default fetchConfig;
